export const TIME_MASK = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
export { APP_VERSION } from './changelog.data';
